module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-prologue element-with-heading",
    attrs: {
      "id": "prologue"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "prologue-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Prologue")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "prologue-text"
    }
  }, [_c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote-container prose without-attribution"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution"
  }, [_c('div', {
    staticClass: "blockquote-image-block blockquote-image-aspect-wide"
  }, [_c('div', {
    staticClass: "blockquote-image-size-container"
  }, [_c('img', {
    staticClass: "blockquote-image-image",
    attrs: {
      "alt": "",
      "src": "images/blockquote-big-66-screen.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first blockquote-position-last"
  }, [_vm._v("We are born in debt, owing the world a death.”    "), _c('i', [_vm._v("~David J. Morris")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ornamental-break"
  }, [_c('div', {
    staticClass: "ornamental-break-block ornamental-break-aspect-wide"
  }, [_c('div', {
    staticClass: "ornamental-break-size-container ornamental-break-width-188"
  }, [_c('img', {
    staticClass: "ornamental-break-image",
    attrs: {
      "alt": "",
      "src": "images/break-section-side-screen.png"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "first first-in-section first-full-width"
  }, [_c('span', {
    staticClass: "first-phrase"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("My name is")]), _vm._v(" Angela Rossi,")]), _vm._v(" and this is the story of how I die...")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I once was a doctor, a wife, a daughter, a sister, a lover... Now I’m a fugitive, hiding from an enemy targeting everyone I hold dear.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("This is a story of good and evil, of temptation and betrayal, of love and obsession.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("I’m dying and alone, exiled from the people I love most, and this is the story of how I save the world.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("At least I hope so.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Because, if I fail, you may be next...")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dbcbfc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/prologue.vue
// module id = 72
// module chunks = 0